"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobFilter = void 0;
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var useSearchDebounce_1 = require("../hooks/useSearchDebounce");
var get_job_types_1 = require("../api/calls/jobs/get_job_types");
var get_locations_1 = require("../api/calls/jobs/get_locations");
var get_categories_1 = require("../api/calls/jobs/get_categories");
var JobFilter = function (props) {
    var _a = (0, useSearchDebounce_1.useSearchDebounce)(), search = _a.search, setSearchQuery = _a.setSearchQuery;
    var onFilterChange = props.onFilterChange;
    var _b = (0, react_1.useState)({}), filters = _b[0], setFilters = _b[1];
    var keyword = filters.keyword, location = filters.location, category = filters.category, jobtype = filters.jobtype, remote_ok = filters.remote_ok;
    var _c = (0, react_1.useState)([]), categories = _c[0], setCategories = _c[1];
    var _d = (0, react_1.useState)([]), jobTypes = _d[0], setJobTypes = _d[1];
    var _e = (0, react_1.useState)([]), locations = _e[0], setLocations = _e[1];
    (0, react_1.useEffect)(function () {
        if (search) {
            onFilterChange(__assign(__assign({}, filters), { keyword: search }));
        }
    }, [search]);
    (0, react_1.useEffect)(function () {
        getJobTypes();
        getCategories();
        getLocations();
    }, []);
    var getJobTypes = function () {
        (0, get_job_types_1.get_job_types)().then(function (response) {
            var _a, _b, _c;
            if (response.error === false) {
                var data = (_c = (_b = (_a = response.results) === null || _a === void 0 ? void 0 : _a.jobtypes) === null || _b === void 0 ? void 0 : _b.map(function (i) { return ({
                    label: i.name,
                    value: i.slug,
                }); })) !== null && _c !== void 0 ? _c : [];
                setJobTypes(data);
            }
        });
    };
    var getLocations = function () {
        (0, get_locations_1.get_locations)().then(function (response) {
            var _a, _b, _c;
            if (response.error === false) {
                var data = (_c = (_b = (_a = response.results) === null || _a === void 0 ? void 0 : _a.locations) === null || _b === void 0 ? void 0 : _b.map(function (i) { return ({
                    label: i.name,
                    value: i.slug,
                }); })) !== null && _c !== void 0 ? _c : [];
                setLocations(data);
            }
        });
    };
    var getCategories = function () {
        (0, get_categories_1.get_categories)().then(function (response) {
            var _a, _b, _c;
            if (response.error === false) {
                var data = (_c = (_b = (_a = response.results) === null || _a === void 0 ? void 0 : _a.categories) === null || _b === void 0 ? void 0 : _b.map(function (i) { return ({
                    label: i.name,
                    value: i.slug,
                }); })) !== null && _c !== void 0 ? _c : [];
                setCategories(data);
            }
        });
    };
    var onChange = function (field, value) {
        var _a;
        var updatedFilters = __assign(__assign({}, filters), (_a = {}, _a[field] = value, _a));
        if (field === "keyword" && typeof value === "string") {
            setSearchQuery(value);
        }
        else {
            onFilterChange(updatedFilters);
        }
        setFilters(updatedFilters);
    };
    var onClear = function () {
        onFilterChange({});
        setFilters({});
        setSearchQuery("");
    };
    return (react_1.default.createElement("div", { className: "sticky top-0" },
        react_1.default.createElement(doshx_controls_web_1.BoxControl, { className: "bg-white shadow-md w-full", variant: "filled", addPadding: false },
            react_1.default.createElement("div", { className: "flex flex-col gap-1 p-8" },
                react_1.default.createElement("h2", { className: "hidden" }, "Filter Jobs"),
                react_1.default.createElement("div", { className: "flex flex-col gap-4 py-3" },
                    react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Search Jobs", startIcon: pro_solid_svg_icons_1.faSearch, size: "small", value: keyword !== null && keyword !== void 0 ? keyword : "", onChange: function (value) { return onChange("keyword", value); } }),
                    react_1.default.createElement(doshx_controls_web_1.DropdownControl, { options: locations, errorTextColor: "text-red-500", label: "Location (".concat(locations.length, ")"), size: "small", disabled: locations.length === 0, value: location !== null && location !== void 0 ? location : "", onChange: function (v) { return onChange("location", v); } }),
                    react_1.default.createElement(doshx_controls_web_1.DropdownControl, { options: categories, errorTextColor: "text-red-500", label: "Category (".concat(categories.length, ")"), size: "small", disabled: categories.length === 0, value: category !== null && category !== void 0 ? category : "", onChange: function (v) { return onChange("category", v); } }),
                    react_1.default.createElement(doshx_controls_web_1.DropdownControl, { options: jobTypes, errorTextColor: "text-red-500", label: "Job Type (".concat(jobTypes.length, ")"), size: "small", disabled: jobTypes.length === 0, value: jobtype !== null && jobtype !== void 0 ? jobtype : "", onChange: function (v) { return onChange("jobtype", v); } }),
                    react_1.default.createElement(doshx_controls_web_1.SwitchControl, { label: "Remote Ok", checked: remote_ok !== null && remote_ok !== void 0 ? remote_ok : false, onChange: function (checked) { return onChange("remote_ok", checked ? true : false); }, colors: {
                            thumbColor: remote_ok ? "bg-blue-500" : "bg-gray-500",
                            titleColor: "text-blue-500",
                            errorTextColor: "text-red-500",
                        } }),
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Clear", backgroundColor: "bg-primary", size: "small", onClick: function () { return onClear(); } }))))));
};
exports.JobFilter = JobFilter;
